import { contractsType } from '@config/types'

const CONTRACTS_CONFIG: contractsType = {
  mainnet: {
    nft_gate: '0x8F83E92251DFb7b87aDd1493FCB763733c2abcAB',
    avatar: '0xd2B234D3b5FF82071fa62D9e21357A4bad1A8851',
    items: '0xdE65bf848a2e285c16F6A32151C3c9ebC07D0E0d',
    level: '0xd35bA1B49B8f5013A53d641eAe8ef19F86634b86',
    marketplace: '0xdE65bf848a2e285c16F6A32151C3c9ebC07D0E0d',
    marketplaceFees: '0x27fC323216BAeee0eB4F059fCA7a5877ee2B4281',
    paymaster: '0xb4aEd40D92Ac7b01F5C75795d7f089ab70b00188',
    lootdrop: '0x',
    achievoWallet: '0x'
  },
  testnet: {
    nft_gate: '0x6E03Ea6c9aBBb78Dd761b9c71c06176c508488C3',
    avatar: '0x825e09e6c56Efdd50834D7418622d9963735ae88',
    items: '0xA8fcDa63bcD7B4d849f11015DB318Ed03EB413D9',
    level: '0xd0923836cCADc49e0cE8670F055c6f4939D08061',
    marketplace: '0xdE65bf848a2e285c16F6A32151C3c9ebC07D0E0d',
    marketplaceFees: '0x27fC323216BAeee0eB4F059fCA7a5877ee2B4281',
    paymaster: '0x2DF1c66a5180B9F9ae07FD34A34c97713219624D',
    lootdrop: '0x',
    achievoWallet: '0x'
  }
}

export default CONTRACTS_CONFIG
